import { render, staticRenderFns } from "./CopyField.vue?vue&type=template&id=2d84c9bd&scoped=true&"
import script from "./CopyField.vue?vue&type=script&lang=js&"
export * from "./CopyField.vue?vue&type=script&lang=js&"
import style0 from "./CopyField.vue?vue&type=style&index=0&id=2d84c9bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d84c9bd",
  null
  
)

export default component.exports